import React, {
    Fragment,
} from 'react'
import classnames from 'classnames'
import { Helmet } from 'react-helmet'

import Configurator from '../../../configurator'
import { i18n } from '../../../validator'
import { NavLink } from '../../../front/components/shared/sn-link'

@i18n()
export default class OrganiserButton extends Configurator {
    getImage = highlighted => highlighted ? `${this.config.REACT_APP_IMAGES_FOLDER}icons/organizer-dark.svg` : `${this.config.REACT_APP_IMAGES_FOLDER}icons/organizer.svg`

    render = () => {
        const { t } = this.props
        let highlighted = this.config.locationSearch === '?jsem-organizator'

        return (
            <Fragment>
                <NavLink to="/jsem-organizator" className={classnames({
                    'Header-buttons--element': true,
                    'Header-buttons--element-green': highlighted,
                })}>
                    <img src={this.getImage(highlighted)} alt="" />
                    <div className="landing">
                        {t('organizerButtonText')}
                    </div>
                </NavLink>
                {highlighted &&
                    <Helmet
                        meta={[
                            {
                                name: 'robots',
                                content: 'noindex, nofollow',
                            },
                        ]}
                    />
                }
            </Fragment>
        )
    }
}
